import React from "react";
import { Spin } from "antd";

export default function Preloader() {
  return (
    <div
      className="preloader"
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height:"85vh",
        zIndex: 2000,
        // background: "#fff",
        // opacity:0.4,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
      <Spin size="large" />
    </div>
  );
}
